/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Service-level information with cost and resources
 */
export interface CloudCostMgmtServiceInfo { 
    /**
     * AWS service name
     */
    name: string;
    /**
     * AWS region
     */
    region: string;
    /**
     * Monthly cost in USD
     */
    cost: number;
    /**
     * Total number of resources
     */
    resources: number;
    /**
     * Number of unused resources
     */
    unused: number;
    /**
     * Breakdown of resource counts by type
     */
    resource_types?: { [key: string]: number; };
}

